module.exports = __webpack_public_path__ + "img/wechatMaterial.8d811765.svg";